import React from 'react';
import { ISeatDisplayInfo } from '../services/plan-info';

interface SeatProps {
    seatInfo: ISeatDisplayInfo;
    onClick: (seatInfo: ISeatDisplayInfo) => void;
    onContextMenu?: (event: React.MouseEvent<HTMLDivElement>, seatInfo: ISeatDisplayInfo) => void;
    devMode: boolean;
    stopClickPropagation?: boolean;
    seatRotation?: number;
}

export const Seat: React.FC<SeatProps> = (props) => {
    const className = 'fa fa-chair seat ' + props.seatInfo.state.toString();
    const devInfo = props.devMode ? ' ' + props.seatInfo.state + ' ' + props.seatInfo.restriction : '';
    const seatRotation =
        props.seatRotation !== undefined && props.seatRotation !== null && !Number.isNaN(props.seatRotation)
            ? props.seatRotation
            : 0;
    return (
        <div
            onClick={(event) => {
                if (props.stopClickPropagation) {
                    event.stopPropagation();
                }
                props.onClick(props.seatInfo);
            }}
            onContextMenu={(event) => {
                if (!props.onContextMenu) {
                    return;
                }
                event.preventDefault();
                props.onContextMenu(event, props.seatInfo);
            }}
        >
            <i
                className={className}
                style={{
                    transform: `rotate(${seatRotation}deg)`,
                    transformOrigin: 'center center',
                    display: 'inline-block',
                }}
                title={
                    props.seatInfo.blockName + ' Reihe ' + props.seatInfo.row + '/Sitz ' + props.seatInfo.seat + devInfo
                }
            ></i>
        </div>
    );
};
